(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ProfileCriterionController', ProfileCriterionController);

    ProfileCriterionController.$inject = ['$scope', '$state', 'ProfileCriterion', 'ProfileCriterionSearch'];

    function ProfileCriterionController ($scope, $state, ProfileCriterion, ProfileCriterionSearch) {
        var vm = this;

        vm.profileCriteria = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            ProfileCriterion.query(function(result) {
                vm.profileCriteria = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ProfileCriterionSearch.query({query: vm.searchQuery}, function(result) {
                vm.profileCriteria = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();
